import React, { useContext, useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IILPPaid, ISwapFees } from '../../api/interfaces'
import { ThemeContext } from '../../App'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { colors } from '../../const'
import { useChartData } from '../../hooks/useChartData'

async function getILPPaidConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_ilp_paid', timeframe)) as IILPPaid[]
	const btcData = chartData.filter((row) => row.LABEL === 'BTC')
	const ethData = chartData.filter((row) => row.LABEL === 'ETH')
	const bchData = chartData.filter((row) => row.LABEL === 'BCH')
	const avaxData = chartData.filter((row) => row.LABEL === 'AVAX')
	const bnbData = chartData.filter((row) => row.LABEL === 'BNB')
	const dogeData = chartData.filter((row) => row.LABEL === 'DOGE')
	const ltcData = chartData.filter((row) => row.LABEL === 'LTC')
	const atomData = chartData.filter((row) => row.LABEL === 'GAIA')

	const series1 = btcData.map((element: IILPPaid) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.ILP_PAID_USD }
	})
	const series2 = ethData.map((element: IILPPaid) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.ILP_PAID_USD }
	})
	const series3 = bchData.map((element: IILPPaid) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.ILP_PAID_USD }
	})
	const series4 = avaxData.map((element: IILPPaid) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.ILP_PAID_USD }
	})
	const series5 = bnbData.map((element: IILPPaid) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.ILP_PAID_USD }
	})
	const series6 = dogeData.map((element: IILPPaid) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.ILP_PAID_USD }
	})
	const series7 = ltcData.map((element: IILPPaid) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.ILP_PAID_USD }
	})
	const series8 = atomData.map((element: IILPPaid) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.ILP_PAID_USD }
	})
	const series9 = ethData.map((element: IILPPaid) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.ILP_PAID_USD_CUMULATIVE }
	})
	const config: IChart[] = [
		{
			data: series9,
			strokeWidth: 2,
			name: 'TOTAL',
			type: 'line',
			seriesGroup: ' [usd]',
			color: `${color}`,
			unitSymbol: '$'
		},
		{
			data: series1,
			strokeWidth: 2,
			name: 'BTC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[0]}`,
			unitSymbol: '$',
			barGroup: 'stacked'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'ETH',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[1]}`,
			unitSymbol: '$',
			barGroup: 'stacked'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: 'BCH',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[2]}`,
			unitSymbol: '$',
			barGroup: 'stacked'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: 'AVAX',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[3]}`,
			unitSymbol: '$',
			barGroup: 'stacked'
		},
		{
			data: series5,
			strokeWidth: 2,
			name: 'BNB',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[4]}`,
			unitSymbol: '$',
			barGroup: 'stacked'
		},
		{
			data: series6,
			strokeWidth: 2,
			name: 'DOGE',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[5]}`,
			unitSymbol: '$',
			barGroup: 'stacked'
		},
		{
			data: series7,
			strokeWidth: 2,
			name: 'LTC',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[6]}`,
			unitSymbol: '$',
			barGroup: 'stacked'
		},
		{
			data: series8,
			strokeWidth: 2,
			name: 'ATOM',
			type: 'bars',
			seriesGroup: '[usd]',
			color: `${colors[7]}`,
			unitSymbol: '$',
			barGroup: 'stacked'
		}
	]
	return { config: config, latestValue: series2[series2.length - 1].y, latestValueDate: series2[series2.length - 1].x }
}

const ILPPaid = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getILPPaidConfig, '1m')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="ILP Paid"
			chartDesc="Cumulative Impermanent Loss Protection (ILP) payouts made by the protocol to liquidity providers, broken down by chain."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="81903a47-6a49-4104-8f4e-ea370257729e"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			sortByValueDesc={true}
		/>
	)
}

export default ILPPaid
